export default "__VITE_ASSET__fec3d8ea__"